import * as Api from '../api/tools';
import { pendingTask, begin, end, endAll } from 'react-redux-spinner';
import constants from '../constants'
import { bindActionCreators } from 'redux';
import { stepValidation } from '../lib/step_validations';
import { updateDoorPreview } from './door_preview'
import _ from 'lodash'

export const sendOrderSuccess = () => ({
  type: constants.ACTIONS.SEND_ORDER_SUCCESS,
  [pendingTask]: end
});

export const addToActionsChain = (actions) => ({
  type: constants.ACTIONS.ADD_TO_ACTIONS_CHAIN,
  payload: actions
});

export const removeFromActionsChain = (action) => ({
  type: constants.ACTIONS.REMOVE_FROM_ACTIONS_CHAIN,
  payload: action
});

export const sendOrderStart = () => ({
  type: constants.ACTIONS.SEND_ORDER_START,
  [pendingTask]: begin
});

export const selectGroup = (group, slug) => (dispatch, getState) => {
  let state = getState();

  if (state.orderState.groups.size.selected != slug) {
    dispatch({
      type: constants.ACTIONS.GROUP_SELECTED,
      payload: {
        construction: state.constructionsState.selected_type,
        group: group,
        slug: slug,
      }
    });
  }
  bindActionCreators(updateDoorPreview, dispatch)(getState());
  bindActionCreators(validateStep, dispatch)(getState());
};

export const customSizeSelected = (sizes, inputValues) => (dispatch, getState) => {
  dispatch({
    type: constants.ACTIONS.CUSTOM_SIZE_SELECTED,
    payload: {
      sizes: sizes,
      inputValues: inputValues
    }
  });

  bindActionCreators(updateDoorPreview, dispatch)(getState());
  bindActionCreators(validateStep, dispatch)(getState());
};

export const sizeSelected = (size) => (dispatch, getState) => {
  dispatch({
    type: constants.ACTIONS.SIZE_SELECTED,
    payload: {
      size: size,
    }
  });
  bindActionCreators(updateDoorPreview, dispatch)(getState());
  bindActionCreators(validateStep, dispatch)(getState());
};

export const constructionPartSelected = (item) => (dispatch, getState) => {
  dispatch({
    type: constants.ACTIONS.CONSTRUCTION_PART_SELECTED,
    payload: {
      item: item,
    }
  });
  bindActionCreators(updateDoorPreview, dispatch)(getState());
  bindActionCreators(validateStep, dispatch)(getState());
};

export const constructionItemSelected = (item, group) => (dispatch, getState) => {
  dispatch(removeFromActionsChain(group));
  dispatch({
    type: constants.ACTIONS.CONSTRUCTION_ITEM_GROUPED_SELECTED,
    payload: {
      item: item,
      group: group
    }
  });
  bindActionCreators(updateDoorPreview, dispatch)(getState());
  bindActionCreators(validateStep, dispatch)(getState());
};

export const setDefaultOrderState = () => (dispatch, getState) => {
  let state = getState();

  dispatch({
    type: constants.ACTIONS.SET_DEFAULT_ORDER_STATE,
    payload: {
      construction: state.constructionsState.selected_type,
    }
  });
  bindActionCreators(updateDoorPreview, dispatch)(getState());
  bindActionCreators(validateStep, dispatch)(getState());
};

export const openTypeSelected = (item) => (dispatch, getState) => {
  dispatch({
    type: constants.ACTIONS.OPEN_TYPE_SELECTED,
    payload: {
      item: item
    }
  });
  bindActionCreators(updateDoorPreview, dispatch)(getState());
  bindActionCreators(validateStep, dispatch)(getState());
};

export const sendOrder = () => (dispatch, getState) => {
  dispatch(sendOrderStart());

  return Api.ajax({
    url: constants.API.ROUTES.ORDERS_PATH,
    method: 'POST',
    params: collectOrderParams(getState())
  }).then(response => {
    bindActionCreators(setDefaultOrderState, dispatch)(getState());
  }).catch(error => {
    throw(error);
  });
};

export const updateOrderParams = (params) => (dispatch, getState) => {
  dispatch({
    type: constants.ACTIONS.UPDATE_ORDER_PARAMS,
    payload: {buyer: params}
  });
};

export const stepValid = (params) => (dispatch, getState) => {
  dispatch({
    type: constants.ACTIONS.STEP_VALID,
    payload: params
  });
};

export const stepInvalid = (params) => (dispatch, getState) => {
  dispatch({
    type: constants.ACTIONS.STEP_INVALID,
    payload: params
  });
};

export const showHint = (params) => (dispatch, getState) => {
  dispatch({
    type: constants.ACTIONS.SHOW_HINT,
    payload: params
  });
};

export const hideHint = () => (dispatch, getState) => {
  dispatch({
    type: constants.ACTIONS.HIDE_HINT
  });
};

export const setForcePopupFor = (name) => (dispatch, getState) => {
  dispatch({
    type: constants.ACTIONS.SET_FORCE_POPUP_FOR,
    payload: {needForcePopupFor: name}
  });
};

export const validateStep = () => (dispatch, getState) => {
  var
    step = detectStepFromURL(),
    { orderState: { groups }, constructionsState: { selected_type } } = getState(),
    validates = selected_type && selected_type.construction_type_options;

  if (!validates) {
    return bindActionCreators(stepValid, dispatch)({step: step});
  }
  const errors = stepValidation(step, selected_type, groups);

  if (errors.length) {
    bindActionCreators(stepInvalid, dispatch)({errors: errors, step: step});
  } else {
    bindActionCreators(stepValid, dispatch)({step: step});
  }

};

const collectOrderParams = ({orderState, doorPreviewState}) => {
  let orderItems = [];

  for (let key in orderState.groups) {
    let
      title = constants.PART_TITLES[key],
      currentItem = orderState.groups[key];

    if (key == 'size' && currentItem.selected == 'CUSTOM_SIZE') {
      let
        sizes = currentItem.items,
        size = {title: `${sizes[0].size_type}: ${sizes[0].value}, ${sizes[1].size_type}: ${sizes[1].value}`};
      orderItems.push(buildParamForItem(title, size));
    } else if (key == 'parts') {
      orderState.groups[key].forEach((item) => {
        item && orderItems.push(buildParamForItem(title, item));
      });
    } else if (currentItem.hasOwnProperty('item')) {
      orderItems.push(buildParamForItem(title, currentItem.item));
    } else if (currentItem.hasOwnProperty('items')) {
      currentItem.items[0] && orderItems.push(buildParamForItem(title, currentItem.items[0]));
    } else if (currentItem) {
      orderItems.push(buildParamForItem(title, currentItem));
    }
  }

  return {
    order_positions_attributes: orderItems,
    name: orderState.buyer.name,
    phone: orderState.buyer.phone,
    comment: orderState.buyer.comment,
    total_sum: doorPreviewState.total_price,
    order_comment: doorPreviewState.comment,
  };
};

const buildParamForItem = (key, item) => {
  if (item) {
    return { title: `${key} - ${item.title || item.value}`, price: item.price || 0 }
  } else {
    return null;
  }
};

const detectStepFromURL = () => {
  let path = window.location.pathname;
  if (path == '/') {
    return 1
  } else {
    if (path.split('-')[0] == '/step') {
      return path.split('-')[1];
    } else {
      return null;
    }
  }
};




// WEBPACK FOOTER //
// ./app/javascript/app/actions/order_actions.js